import { AnalyticsContextValue } from "@swiggy-private/analytics";
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, LABEL_NAME, SCREEN_NAME } from "../constants";

export const onClickTurboStrip = (
    isNewBanner: boolean,
    bannerId: string,
    stripMsg: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TURBO_STRIP,
        context: JSON.stringify({ bannerId, isNewBanner }),
        label: stripMsg,
    });
};

export const onImpressionTurboStrip = (
    isNewBanner: boolean,
    bannerId: string,
    stripMsg: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TURBO_STRIP,
        context: JSON.stringify({ bannerId, isNewBanner }),
        label: stripMsg,
    });
};

// TurboTooltip analytics
export const onImpressionTurboTooltip = (
    campaignId: string,
    stripMsg = "",
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        label: LABEL_NAME.TURBO_WIDGET_TOOLTIP,
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_TOOLTIP,
        context: JSON.stringify({ campaignId, stripMsg }),
    });
};

export const onClickTurboTooltipClose = (
    campaignId: string,
    stripMsg = "",
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        label: LABEL_NAME.TURBO_WIDGET_TOOLTIP_CROSS,
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_TOOLTIP_CLOSE,
        context: JSON.stringify({ campaignId, stripMsg }),
    });
};
